// extracted by mini-css-extract-plugin
export default {"container":"QuickStakeButtons_container__5oSsq","button":"QuickStakeButtons_button__3guaf"};